import { useContext, useMemo, useSyncExternalStore } from '@wordpress/element';
import SlotFillContext from '../context';
function useObservableValueWithSelector(map, name, selector) {
  const subscribe = useMemo(() => listener => map.subscribe(name, listener), [map, name]);
  const getValue = () => selector(map.get(name));
  return useSyncExternalStore(subscribe, getValue, getValue);
}
function getLength(array) {
  return array?.length;
}
export default function useSlotFills(name) {
  const registry = useContext(SlotFillContext);
  const length = useObservableValueWithSelector(registry.fills, name, getLength);
  // callers expect an opaque array with length `length`, so create that array
  const fills = useMemo(() => {
    return length !== undefined ? Array.from({
      length
    }) : undefined;
  }, [length]);
  return fills;
}